/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_History_Last_7_DaysInputs */



/**
* | output |
* | --- |
* | "Last 7 days" |
*
* @param {Assistant_History_Last_7_DaysInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_history_last_7_days = /** @type {((inputs?: Assistant_History_Last_7_DaysInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_History_Last_7_DaysInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les 7 derniers jours")
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzte 7 Tage")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ultimi 7 giorni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Последние 7 дней")
	if (locale === "es") return /** @type {LocalizedString} */ ("Últimos 7 días")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("过去7天")
	if (locale === "ja") return /** @type {LocalizedString} */ ("過去7日間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछले 7 दिन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Últimos 7 dias")
	return /** @type {LocalizedString} */ ("Last 7 days")
});